import React, { useEffect, useState } from "react";
import Footer from "../../components/footer/footer";
import Navbar from "../../components/navbar/Navbar";
import AboutUsSection from "./AboutUsSection";
import AdvisoryCounsil from "./AdvisoryCounsil";
import HeroSectionAboutUs from "./HeroSectionAboutUs";
import MissionSection from "./MissionSection";
import VisionSection from "./VisionSection";
import InterestedSectionMain from "../../components/interested section/InterestedSectionMain";
import WOW from "wowjs";

function AboutUsMain(props) {
  useEffect(() => {
    new WOW.WOW({
      animateClass: "animated",
      offset: 160,
      callback: function (box) {},
    }).init();
  }, []);
  return (
    <div className="about_us_main_container">
      <div className="nav_container">
        <Navbar fromPage="aboutusmain" />
      </div>
      <HeroSectionAboutUs />
      <AboutUsSection />

      <AdvisoryCounsil />
      <VisionSection />
      <MissionSection />
      <InterestedSectionMain />
      <Footer />
    </div>
  );
}

export default AboutUsMain;
